import React from "react";
import AssetCourseMappingsTable from "./components/AssetCourseMappingsTable";

export default function AssetCourseMappingsPage() {
  return (
    <div className="grid h-full min-h-0 grid-cols-1 gap-5">
      <AssetCourseMappingsTable />
    </div>
  );
}


